module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IGiftCardRedeemedAlertJson extends IAlertJSON {
        olderThanMonths: number;
    }

    class MeevoGiftCardsRedeemedConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public selectedMonths: number;

        get dataForReview() {
            return [
                this.selectedMonths
            ];
        }

        get alertConfiguration() {
            return {
                olderThanMonths: this.selectedMonths
            }
        }

        get months(): number[] {
            return _.range(1, 100, 1);
        }

        constructor(protected alertsManagerService: IAlertsManagerService) {
            super(alertsManagerService);

            this.selectedMonths = 1;
        }

        onEdit(alertJSON: IGiftCardRedeemedAlertJson): void {
            this.selectedMonths = alertJSON.olderThanMonths;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoGiftCardsRedeemedConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/gift-cards-redeemed-config/gift-cards-redeemed-config.component.html',
            controller: MeevoGiftCardsRedeemedConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}